module.exports = __webpack_public_path__ + "static/img/attention.3a486ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/attention.png
// module id = hU+9
// module chunks = 0